import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ReadMoreInterface } from "../readMore/interfaces";
import { ReadMore } from "../readMore/readMoreController";
import { IShowHide, ShowHide } from "../showHide/showHideController";

export interface IReviewWidgetPagerReview extends IInstanceComponentBase {
    readMore: ReadMoreInterface;
}

export class ReviewWidgetPagerReview extends InstanceComponentBase implements IReviewWidgetPagerReview {
    public readMore: ReadMoreInterface;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);

        this.initialiseReadMore();
    }

    initialiseReadMore() {
        try {
            let readMoreToggleElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReadMore.ReadMoreToggle)) as HTMLElement;
            let readMoreContentElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReadMore.ReadMoreContent)) as HTMLElement;
            if (readMoreToggleElement != null && readMoreContentElement != null) {
                this.readMore = new ReadMore(readMoreToggleElement, readMoreContentElement);
            }
        } catch (error) {
            console.log('ReviewWidgetPagerReview: initialiseReadMore Error', error);
        }
    }

    dispose() {
        try {
            console.log(`ReviewWidgetPagerReview: dispose`);

            if (this.readMore != null) {
                this.readMore.dispose();
            }
           
        } catch (error) {
            console.log(`ReviewWidgetPagerReview: dispose Error:`, error);
        }
    }

    delete(): void {
        
    }
}